import { IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import ReactGA from 'react-ga4';

const whatsappMessage = 'Hola desde Wezpi, me gustaría hacer un pedido';

const PhoneList = ({ phones, linkType, business, children }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const registerEvent = (phone) => {
    const message = linkType === 'phone' ?
      `Tel: ${business.id} ${business.name} ${phone.trim()}`:
      `Wap: ${business.id} ${business.name} ${phone.trim()}`;
    const category_name = linkType === 'phone' ?
      'clic_tel':
      'clic_wap';
    ReactGA.event({
      category: category_name,
      action: message,
    });
  };
  return (
    <>
    { phones.length === 1 && 
      <Link to={
          linkType === 'phone' ? `tel:${phones[0].trim()}`
          : `https://wa.me/${phones[0].trim()}?text=${encodeURIComponent(whatsappMessage)}`
        }
        onClick={ () => { registerEvent(phones[0]) } }
        style={{ textDecoration: 'none' }} target='_blank'>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-controls="menu-appbar"
          aria-label="menu"
          sx={{ mr: 2 }}
        >
          { children }
        </IconButton>
      </Link>
    }
    { phones.length > 1 &&
      <>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-controls="menu-appbar"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={handleClick}
        >
          { children }
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
        {phones.map((phone, index) => {
          return (
            <MenuItem
              component={Link}
              to={
                linkType === 'phone' ? `tel:${phone.trim()}`
                : `https://wa.me/${phone.trim()}?text=${encodeURIComponent(whatsappMessage)}`
              }
              onClick={ () => { registerEvent(phones[0]) } }
              target="_blank"
            >
              {phone.trim()}
            </MenuItem>
          );
        })}
        </Menu>
      </>
    }
    </>
  );
};

export default PhoneList;
